var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSearchChip = function SvgIconSearchChip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M14 2.5H4c-1.125 0-2 .875-2 2v10c0 1.125.875 2 2 2h5.75C9.25 15.813 9 14.938 9 14v-.5c-.25 0-.5-.25-.5-.5v-3c0-.25.25-.5.5-.5s.5.25.5.5v1.938c.5-1 1.438-1.813 2.5-2.188V6c0-.25.25-.5.5-.5s.5.25.5.5v3.563h.5c.938 0 1.813.25 2.5.75V4.5c0-1.125-.875-2-2-2M6 13c0 .25-.25.5-.5.5S5 13.25 5 13V8c0-.25.25-.5.5-.5s.5.25.5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m18.875 18.625-2.563-2.5c1.125-1.563.813-3.75-.687-4.875-1.563-1.188-3.75-.813-4.875.687-1.188 1.563-.813 3.75.687 4.875.625.438 1.313.688 2.063.688.812 0 1.5-.25 2.125-.688l2.562 2.563a.49.49 0 0 0 .688 0c.187-.25.187-.563 0-.75M13.5 16.5A2.507 2.507 0 0 1 11 14c0-1.375 1.125-2.5 2.5-2.5S16 12.625 16 14s-1.125 2.5-2.5 2.5"
  })));
};
export default SvgIconSearchChip;